import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	loadMore: {
		id: 'issue-history.history-items.load-more',
		defaultMessage: 'Load more',
		description: 'Button label - when clicked, will load more history items for history feed',
	},
});
